"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RangeOperators;

(function (RangeOperators) {
  RangeOperators["and"] = "&&";
  RangeOperators["none"] = "none";
})(RangeOperators = exports.RangeOperators || (exports.RangeOperators = {}));

var RULE_OPERATORS;

(function (RULE_OPERATORS) {
  RULE_OPERATORS["greaterThan"] = ">";
  RULE_OPERATORS["greaterThanOrEqualTo"] = ">=";
  RULE_OPERATORS["lessThan"] = "<";
  RULE_OPERATORS["lessThanOrEqualTo"] = "<=";
  /* waiting feedback from UX for these three operation since these three are not range operation */

  RULE_OPERATORS["equalTo"] = "==";
  RULE_OPERATORS["inTop"] = "inTop";
  RULE_OPERATORS["inBottom"] = "inBottom";
  RULE_OPERATORS["missing"] = "missing";
})(RULE_OPERATORS = exports.RULE_OPERATORS || (exports.RULE_OPERATORS = {}));

var CONDITION_TYPES;

(function (CONDITION_TYPES) {
  CONDITION_TYPES["GTE"] = "GTE";
  CONDITION_TYPES["LTE"] = "LTE";
  CONDITION_TYPES["GT"] = "GT";
  CONDITION_TYPES["LT"] = "LT";
  CONDITION_TYPES["ET"] = "ET";
  CONDITION_TYPES["IT"] = "IT";
  CONDITION_TYPES["IB"] = "IB";
  CONDITION_TYPES["MI"] = "MI";
})(CONDITION_TYPES = exports.CONDITION_TYPES || (exports.CONDITION_TYPES = {}));

var RULE_SCALES;

(function (RULE_SCALES) {
  RULE_SCALES["PERCENTAGE"] = "%";
  RULE_SCALES["NUMERIC"] = "#";
})(RULE_SCALES = exports.RULE_SCALES || (exports.RULE_SCALES = {}));

var RULE_TYPES;

(function (RULE_TYPES) {
  RULE_TYPES["THRESHOLD"] = "threshold";
  RULE_TYPES["RANGE"] = "range";
})(RULE_TYPES = exports.RULE_TYPES || (exports.RULE_TYPES = {}));

var RULE_STYLE_SHAPE;

(function (RULE_STYLE_SHAPE) {
  RULE_STYLE_SHAPE["upArrow"] = "upArrow";
  RULE_STYLE_SHAPE["rightArrow"] = "rightArrow";
  RULE_STYLE_SHAPE["downArrow"] = "downArrow";
  RULE_STYLE_SHAPE["upCaret"] = "upCaret";
  RULE_STYLE_SHAPE["dash"] = "dash";
  RULE_STYLE_SHAPE["downCaret"] = "downCaret";
  RULE_STYLE_SHAPE["checkmark"] = "checkmark";
  RULE_STYLE_SHAPE["warning"] = "warning";
  RULE_STYLE_SHAPE["xSymbol"] = "xSymbol";
  RULE_STYLE_SHAPE["circle"] = "circle";
  RULE_STYLE_SHAPE["triangle"] = "triangle";
  RULE_STYLE_SHAPE["diamond"] = "diamond";
  RULE_STYLE_SHAPE["satisfied"] = "satisfied";
  RULE_STYLE_SHAPE["neutral"] = "neutral";
  RULE_STYLE_SHAPE["dissatisfied"] = "dissatisfied";
  RULE_STYLE_SHAPE["none"] = "none";
})(RULE_STYLE_SHAPE = exports.RULE_STYLE_SHAPE || (exports.RULE_STYLE_SHAPE = {}));

exports.RULE_KPI_LIMIT = 3;
exports.RULE_CONDITION_MAXIMUM_FRACTION_DIGITS = 2;
exports.RULE_DEFAULT_MIN_VALUE = 0;
exports.RULE_DEFAULT_MAX_VALUE = 100;
